import { useEffect, useMemo, useState, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar } from '@/hooks';
import { sidebarItems } from './sidebar';
import { ROUTES } from '@/constants';

export const Notarios = (): ReactElement => {
	const [title, setTitle] = useState<string>('Cargando...');

	// Simula fetch de Strapi
	useEffect(() => {
		const id = setTimeout(() => {
			setTitle('Buscador de notarios');
		}, 200);
		return () => clearTimeout(id);
	}, []);

	usePageBreadcrumb([
		{ label: 'El Colegio', to: ROUTES.COLEGIO_PRESENTACION },
		{ label: 'Organización', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
		{ label: 'Notarios' },
	]);

	// Sidebar estable (memoizado)
	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return <div>Página Notarios</div>;
};
